import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  const links = [
    { name: t('aboutPage.whyChoosePayor'), href: "#" },
    { name: t('aboutPage.ourFeatures'), href: "#" },
    { name: t('aboutPage.customerTestimonials'), href: "#" },
    { name: t('aboutPage.contactUs'), href: "#" },
  ];

  const stats = [
    { name: t('aboutPage.companiesSupported'), value: "1 200+" },
    { name: t('aboutPage.employeesManaged'), value: "50 000+" },
    { name: t('aboutPage.countriesCovered'), value: "15" },
    { name: t('aboutPage.legalCompliance'), value: "100%" },
  ];

  return (
    <section className="relative isolate overflow-hidden bg-neutral-900 py-24 sm:py-32 text-white">
      {/* Image de fond Payor */}
      <img
        src="https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=1600"
        alt="Gestion de paie en Afrique"
        className="absolute inset-0 -z-10 w-full h-full object-cover opacity-30"
      />

      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-5xl font-bold sm:text-7xl">{t('aboutPage.title')}</h2>
          <p className="mt-6 text-lg text-gray-300">
            {t('aboutPage.description')}
          </p>
        </div>

        {/* Liens utiles */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-lg font-semibold">
          {links.map((link) => (
            <a key={link.name} href={link.href} className="text-blue-500 hover:text-blue-300">
              {link.name} &rarr;
            </a>
          ))}
        </div>

        {/* Statistiques de Payor */}
        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.name} className="text-center">
              <dd className="text-4xl font-bold">{stat.value}</dd>
              <dt className="text-lg text-gray-400">{stat.name}</dt>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
